import $ from 'jquery';
window.jQuery = $;
require('jquery.easing');
require('jquery.smoothscroll/dist/jquery.smoothscroll.js');

function CommonCtrl() {
	this.init();
}

CommonCtrl.prototype.init = function() {
	$('a[href^="#"]').SmoothScroll({
    duration: 1000,
    easing: 'easeOutQuint',
    offset: (matchMedia('(max-width: 991px)').matches) ? 0 : 62
  });
}

export default CommonCtrl;

